<template>
  <div :class="className" :style="{height: height,width: width}" />
</template>
<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons')
import resize from '@/mixins/resize'

export default {
  components: {},
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '10rem'
    },
    colorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getLineData(data, date) {
      
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions({ expectedData, actualData } = {}) {
      this.chart.setOption({
        title: {
          show: false,
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: {
            color: '#909399',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#FFFFFF'
            }
          },
          backgroundColor: '#FFFFFF'
        },
        toolbox: {
        },
        legend: {
          data: [
            {icon:'circle',name:'BUZZ'}, 
            {icon:'circle',name:'BUZZ 上月'}, 
            {icon:'circle',name:'NWR'}, 
            {icon:'circle',name:'NWR 上月'}, 
          ],
          left: 'left',
          itemWidth: 10,
          textStyle: {
            color: '#000',
            fontSize: 16
          }
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['拉链', '透气性', '裤脚', '保暖性', '口袋', '面料', '柔软性', '图案', '正品', '质量', '弹性', '细节', '领口'],
            axisPointer: {
              type: 'shadow'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#000',
              fontSize: 16
            },
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            nameLocation:'left',
            nameTextStyle:{
              color: '#000',
              fontSize:14,
              padding:[0,120,-30,0]
            },
            min: -100,
            max: 100,
            interval: 100,
            axisLabel: {
              color: '#000',
              fontSize: 16,
              formatter: '{value}%'
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: '#000'
              },
              textStyle: {
                color: '#000'
              }
            },
            axisTick: {
              show: false,
            },  
            axisLine:{
              show:false
            },
            splitArea : {
              show : false
            },
          },
        ],
        color: ['#234990', '#B3B3B3', '#FFBD00', '#B3B3B3'],
        series: [
          {
            name: 'BUZZ',
            type: 'bar',
            barWidth: 18,
            barGap: 0,
            data: [60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 65, 50]
          },
          {
            name: 'BUZZ 上月',
            type: 'bar',
            barWidth: 18,
            barGap: 0,
            data: [50, 40, 50, 40, 40, 40, 40, 40, 40, 30, 50, 40, 45]
          },
          {
            name: 'NWR',
            type: 'line',
            smooth: false,
            symbolSize: 0,
            data: [20, 90, 95, 70, 30, 70, 95, -60, 50, 80, 90, 30, 40],
          },
          {
            name: 'NWR 上月',
            type: 'line',
            smooth: false,
            symbolSize: 0,
            data: [20, 90, 95, 60, 90, 60, 80, 90, 60, 80, 90, 20, 30]
          }
        ]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/voc/cmetanalys/components/BuzzLineHisChart.vue